import { render, staticRenderFns } from "./RoadClosureInfo.vue?vue&type=template&id=0a162946&scoped=true"
import script from "./RoadClosureInfo.vue?vue&type=script&lang=ts"
export * from "./RoadClosureInfo.vue?vue&type=script&lang=ts"
import style0 from "./RoadClosureInfo.vue?vue&type=style&index=0&id=0a162946&prod&lang=css"
import style1 from "./RoadClosureInfo.vue?vue&type=style&index=1&id=0a162946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a162946",
  null
  
)

export default component.exports